export const EU_FULFILLMENT_METHODS = [
  { name: 'Pan EU', value: 'pan-eu' },
  { name: 'Multi-country Inventory', value: 'fba-export' }
]

export const SELLER_CENTRAL_ROOT_PATH = {
  na: 'https://sellercentral.amazon.com',
  eu: 'https://sellercentral-europe.amazon.com',
  fe: {
    A1VC38T7YXB528: 'https://sellercentral-japan.amazon.com',
    A39IBJ37TRP1C6: 'https://sellercentral.amazon.com.au',
    A19VAU5U5O7RUS: 'https://sellercentral.amazon.sg'
  }
}
